import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 64px 24px 84px;
  padding: 30px 25px 25px;
  border: ${({ isDark }) =>
    isDark ? '1px solid #E7303C' : '1px solid #5e17fe'};
  border-radius: 4px;

  ${mq.medium`
    margin: 64px 40px 84px;
    padding: 30px 40px 40px;
  `}

  ${mq.large`
    margin: 64px 64px 84px;
    padding: 50px 60px 60px;
  `}

  ${mq.xLarge`
    margin: 64px 84px 84px;
    padding: 50px 100px 100px;
  `}

  form {
    width: 100%;
    margin: 140px 0 80px;
  }
`

export default Container
